import { render, staticRenderFns } from "./order-table-item.component.vue?vue&type=template&id=22cd83bf&"
import script from "./order-table-item.component.vue?vue&type=script&lang=js&"
export * from "./order-table-item.component.vue?vue&type=script&lang=js&"
import style0 from "./order-table-item.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cd83bf')) {
      api.createRecord('22cd83bf', component.options)
    } else {
      api.reload('22cd83bf', component.options)
    }
    module.hot.accept("./order-table-item.component.vue?vue&type=template&id=22cd83bf&", function () {
      api.rerender('22cd83bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/order-table-item.component.vue"
export default component.exports